import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../configHelper';

@Injectable({
  providedIn: 'root'
})
export class RequisitionTestDataService {

  constructor(private httpClient: HttpClient, private configService: ConfigService) { 
  }

  public getStatusHistory(id: number) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionTest/GetStatusHistory/?id=${id}`;
    return this.httpClient.get(url);
  }

  public getTestResultReport(id: number) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionTest/GetTestResultReport?id=${id}`;
    return this.httpClient.get(url, { responseType: 'blob' as 'json' });
  }

  public getTestRejectReport(id: number) {
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionTest/GetRejectReport?id=${id}`;
    return this.httpClient.get(url, { responseType: 'blob' as 'json' });
  }

  public setResultComment(requisitionTestResultId: number, comment: string) {
    let dto: any = {};
    dto.requisitionTestResultId = requisitionTestResultId;
    dto.comment = comment;
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionTest/SetResultComment`;
    return this.httpClient.post(url, dto);
  }


  public unreject(accession: string, reqTestId: number, reqTestRejectionId: number, description: string) {
    let dto: any = {};
    dto.Accession = accession;
    dto.RequisitionTestId = reqTestId;
    dto.RequisitionTestRejectionId = reqTestRejectionId;
    dto.Description = description;
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionTest/Unreject`;
    return this.httpClient.post(url, dto);
  }

  public reject(accession: string, id: number, description: string, rejectionTypes, labTestId: number) {
    let dto: any = {};
    dto.Accession = accession;
    dto.RequisitionTestid = id;
    dto.Description = description;
    dto.RejectionTypes = rejectionTypes;
    dto.LabTestId = labTestId
    let url: string = `${this.configService.getConfig().apiURL}v1/Internal/RequisitionTest/Reject`;
    return this.httpClient.post(url, dto);
  }

}
